$(function(){
  $("a,h1,h2,h3,h5,h6,p,span").each(function() {    
    let html = $(this).html();
    html = html.replace("&lt;tc&gt;", "");
    html = html.replace("&lt;/tc&gt;", "");
    $(this).html(html);
  })
})

// >=======================================()-=-=o0o=-=-()=======================================<
// CONSTANTS FOR PRODUCTS
// >=======================================()-=-=o0o=-=-()=======================================<

const productLengthMissingError = locale === 'fr' ? "La longueur est requise" : "The length is required";
const productQuantityError = locale === 'fr' ? "Vous devez entrer une quantité" : "You must enter a quantity";
const productLengthOutOfBoundsError = locale === 'fr' ? "La longueur doit être entre les bornes" : "The length must be within the bounds";
const productOverpriceError = locale === 'fr' ? "Le prix maximal de 10 000$ a été atteint pour ce produit" : "The maximum price of $10,000 has been reached for this product";


// >=======================================()-=-=o0o=-=-()=======================================<
// LENGTH INPUT VALIDATION
// >=======================================()-=-=o0o=-=-()=======================================<

// Displays an error message in the corresponding element
function displayError(elem, msg) {
  elem.textContent = msg;
}

// Clears any error message in the corresponding element
function clearError(elem) {
  elem.textContent = "";
}
// >=======================================()-=-=o0o=-=-()=======================================<
// PRODUCT-SPECIFIC LOGIC
// >=======================================()-=-=o0o=-=-()=======================================<

var isMobile = false;
  // For regular products (Elocone, Crimper, etc)
if (!isDeck && !isGirt) {
  function isElocone() {
    var isProductTitleElocone = false;
	var productTitle = document.getElementById('product_title');
    if ( productTitle !== undefined && productTitle !== null){
      isProductTitleElocone = productTitle.textContent.includes('Elocone');
    }
    return isProductTitleElocone;
  }
  

  function getShippingProvinces(plants) {
    let productProvinces = [];
	if(plants !== null && plants !== undefined)
	{
      plants = Array.from(plants.keys());
      for (const plant in plants) {
        Array.prototype.push.apply(productProvinces, provinceByPlant.get(plants[plant]));
      }
	}
    return new Set(productProvinces);
  }

  function hasShipping() {
    let userProvince = getCookieShippingProvince();
	var productTitle = document.getElementById('product_title');
    let title = "";
    if ( productTitle !== undefined && productTitle !== null){
      title = productTitle.textContent;
    }
    if (isLocaleFR()) {
      title = translation.get(title);
    }
    let plants = regularProductMap.get(title);
    let productProvinces = getShippingProvinces(plants);
    return productProvinces.has(userProvince);
  }

  function setShippingWarningBannerMsg() {
    let provinceShort = getCookieShippingProvince();
    let provinceLong = '';
    if (provinceAbbreviationsFR.has(provinceShort)) {
      if (isLocaleFR()) {
        provinceLong = provinceAbbreviationsFR.get(provinceShort);
        document.getElementById('fr-banner__user-province').textContent = provinceLong;
        document.getElementById('fr_phone').textContent = phoneByProvinceFR.get(provinceShort);
      } else {
        provinceLong = provinceAbbreviationsEN.get(provinceShort);
        document.getElementById('en-banner__user-province').textContent = provinceLong;
        document.getElementById('en_phone').textContent = phoneByProvinceEN.get(provinceShort);
      }
    }
  }

  if (!isElocone() && !isDigital) {
	var shippingWarning = document.getElementById('shipping-warning-banner');
    if ( shippingWarning !== undefined && shippingWarning !== null){
      if (hasShipping() || getCookieShippingProvince() === 'None') {
        shippingWarning.setAttribute('hidden', true);
      } else {
        setShippingWarningBannerMsg();
        shippingWarning.removeAttribute('hidden');
      }
    }
  }
    
  function fillFields(propertiesMap) {
	var quantityProductTemplate = document.getElementById('Quantity-product-template');
	if(propertiesMap.get('quantity') !== undefined && propertiesMap.get('quantity') !== null &&
		quantityProductTemplate !== undefined && quantityProductTemplate !== null){
		quantityProductTemplate.value = propertiesMap.get('quantity');
	}
  }

  function updateQuantity() {
    updatedQuantity =  document.getElementById('Quantity-product-template').value;
  }

  if (!isDigital)
  {
	var quantityProductTemplate = document.getElementById('Quantity-product-template');
    if (quantityProductTemplate !== undefined && quantityProductTemplate !== null){
      quantityProductTemplate.addEventListener("input", () => {
	  updateQuantity();
	})
    }
	
  };

  var isModified = false;
  var modifiedIndex = '';
  var updatedQuantity = 0;
  
  window.addEventListener('load', (event) => {
    const propertiesMap = decodeURL();
    if (propertiesMap.size > 0) {
      isModified = true;
      fillFields(propertiesMap);
      let buttonText = document.getElementById('addToCart_button_text');
      buttonText.textContent = locale === 'fr' ? "Modifier l'item" : "Update product";
      document.getElementById('extra_payment_buttons').setAttribute('hidden', true);
    }
  });
}

function isLocaleFR() {
  return location.href.includes('/fr/');
}

function containsAlphanumericCharacter(str) {
  
   if(str == null || str == '')
      return false;
   var code, i, len;

   for (i = 0, len = str.length; i < len; i++) {
      code = str.charCodeAt(i);
      if ((code > 64 && code < 91) || // upper alpha (A-Z)
      (code > 96 && code < 123)) { // lower alpha (a-z)
         return true;
      }
   }
   return false;
};